"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventOpenScreen = exports.trackEventNoEcommerce = exports.trackEventEcommerce = void 0;

var _reactNativeWeb = require("react-native-web");

var nativeGtm = function nativeGtm() {
  if (_reactNativeWeb.NativeModules.NativeGTM) {
    return _reactNativeWeb.NativeModules.NativeGTM;
  }

  var noOperator = function noOperator() {};

  return {
    trackEventNoEcommerceOnScreen: noOperator,
    trackEventEcommerce: noOperator,
    trackEventOpenScreen: noOperator
  };
};

var webGtm = function webGtm() {
  if (window && window.gtmDataLayer) {
    return window.gtmDataLayer;
  }

  window.gtmDataLayer = [];
  return window.gtmDataLayer;
};

var trackEventNoEcommerce = function trackEventNoEcommerce(_ref) {
  var _ref$screenName = _ref.screenName,
      screenName = _ref$screenName === void 0 ? '' : _ref$screenName,
      category = _ref.category,
      action = _ref.action,
      label = _ref.label;

  if (_reactNativeWeb.Platform.OS === 'web') {
    webGtm().push({
      event: 'trackEventNoEcommerce',
      'eventDetails.category': category,
      'eventDetails.action': action,
      'eventDetails.label': label
    });
  } else {
    nativeGtm().trackEventNoEcommerceOnScreen(screenName, category, action, label);
  }
};

exports.trackEventNoEcommerce = trackEventNoEcommerce;

var trackEventEcommerce = function trackEventEcommerce(eventName, ecommerce) {
  var bookingInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (_reactNativeWeb.Platform.OS === 'web') {
    webGtm().push({
      event: eventName,
      ecommerce: ecommerce
    });
  } else {
    nativeGtm().trackEventEcommerce(eventName, bookingInfo, ecommerce);
  }
};

exports.trackEventEcommerce = trackEventEcommerce;

var trackEventOpenScreen = function trackEventOpenScreen(_ref2) {
  var _ref2$screenName = _ref2.screenName,
      screenName = _ref2$screenName === void 0 ? '' : _ref2$screenName;

  if (_reactNativeWeb.Platform.OS !== 'web') {
    nativeGtm().trackEventOpenScreen(screenName);
  }
};

exports.trackEventOpenScreen = trackEventOpenScreen;